export default __webpack_public_path__ + "static/media/pen_svg.764fb340.svg";